import { render } from "./EmployeeDataImport.vue?vue&type=template&id=29aef9cc&scoped=true"
import script from "./EmployeeDataImport.vue?vue&type=script&lang=js"
export * from "./EmployeeDataImport.vue?vue&type=script&lang=js"

import "./EmployeeDataImport.vue?vue&type=style&index=0&id=29aef9cc&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29aef9cc"]])

export default __exports__